// src/utils/uploadResponses.js (or .ts)
/* ------------------------------------------------------------------ */
/* uploadResponses – Firebase helper                                  */
/* ------------------------------------------------------------------ */

import { getStorage, ref, uploadString } from "firebase/storage";
import { firebaseApp } from "../../firebase/firebaseApp";

/**
 * uploadResponses
 * ---------------
 * Persists a questionnaire-response JSON blob to Cloud Storage.
 * Path template:
 * `questionnaires/{questionnaireName}/{uid}/{ISO-timestamp}-{5rnd}.json`
 *
 * @param {string}  questionnaireName   Slug for the questionnaire (e.g. `"respHealthAssessment"`).
 * @param {object}  formData            Flat `{ id: value }` map of answers.
 * @param {string}  uid                 Firebase Auth `uid` for the current user.
 * @param {object} [storage]            Optional `FirebaseStorage` instance.
 *                                      Defaults to `getStorage(firebaseApp)`.
 * @returns {Promise<void>}             Resolves when the upload completes.
 */
export const uploadResponses = async (
  questionnaireName,
  formData,
  uid,
  takenBy,
  storage = getStorage(firebaseApp)
) => {
  /* ----- build remote path & payload -------------------------------- */
  const now = new Date();
  const iso = now.toISOString().replace(/:/g, "-");
  const rand = Math.random().toString(36).slice(2, 7);
  const file = `${iso}-${rand}.json`;
  const path = `questionnaires/${questionnaireName}/${uid}/${file}`;

  const payload = {
    questionnaire: questionnaireName,
    takenBy,
    submittedAt: now.toISOString(),
    responses: formData,
  };

  /* ----- upload ------------------------------------------------------ */
  const storageRef = ref(storage, path);
  await uploadString(storageRef, JSON.stringify(payload), "raw", {
    contentType: "application/json",
  });
};
